module.exports = __webpack_public_path__ + "img/Logo--Looking-Glass.cd3cb74f.png";